module.exports = __webpack_public_path__ + "static/favicon-b4c85ee0b27a02b45687c266e0ef178f.png";